 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"a4ceecac44264c85db5ffc7c053be1d668a563d6","1":"d1d95a80c372ec5900e3701a5af808ed913408a1","2":"styles","3":"60bd339c77bbb08565e3718576e010113576ed5a","4":"5735565d15280288b03a826f98936cf1739443ba","5":"bc28599f108a18f65c8a668750ca6221ced015bc","6":"1fa6542c36b270a382cfd09df6880ade19db7a3f","7":"231ecdf25ca383381d7680a49c3cb0531a54c36d","8":"eb5a4b780599e191c090b6a3213504cb56648c06","9":"c07283bbcf2ed03c0d7e76967c79f8873c6b2a05","12":"component---src-pages-404-js","13":"component---src-pages-about-js","14":"component---src-pages-activities-js","15":"component---src-pages-adhub-js","16":"component---src-pages-aihub-js","17":"component---src-pages-b-2-b-js","18":"component---src-pages-brandretail-js","19":"component---src-pages-campaign-js","20":"component---src-pages-cdp-js","21":"component---src-pages-childrenprivacy-js","22":"component---src-pages-cookieprivacy-js","23":"component---src-pages-cpm-js","24":"component---src-pages-digitalmarketing-js","25":"component---src-pages-dmhub-js","26":"component---src-pages-durables-js","27":"component---src-pages-financial-js","28":"component---src-pages-fmcg-js","29":"component---src-pages-index-js","30":"component---src-pages-marketingcloud-js","31":"component---src-pages-maturity-js","32":"component---src-pages-modernretail-js","33":"component---src-pages-openhub-js","34":"component---src-pages-partner-js","35":"component---src-pages-pechub-content-list-jsx","36":"component---src-pages-pechub-jsx","37":"component---src-pages-personas-js","38":"component---src-pages-privacy-js","39":"component---src-pages-privatetraffic-js","40":"component---src-pages-royalty-js","41":"component---src-pages-scrm-js","42":"component---src-pages-summits-js","43":"component---src-pages-tags-js","44":"component---src-pages-tahub-js","45":"component---src-pages-update-info-js","46":"component---src-pages-yourtitles-js","47":"component---src-templates-blogs-js","48":"component---src-templates-ccmeaningful-js","49":"component---src-templates-post-layout-jsx","50":"component---src-templates-whitepaper-js"}[chunkId]||chunkId) + "-" + {"0":"67117f4e45b85f9eaa59","1":"a6ded119aab77ad313da","2":"f3e9059f8c2a75df70f2","3":"0f69c6e3ef8cf343e14b","4":"05519384533bcbd78f02","5":"9c270c9c1a07245d9e03","6":"2d5ab89c11672551eed4","7":"fe6e20019c2d6ec32914","8":"66dfbbd06af666ebcd8c","9":"3f0870c3293a5a688c9b","12":"e90c574afa0485512109","13":"8c3b012ff974cc0d9cbe","14":"6cbd4c678d0ea77d2755","15":"8a8439b22519b56882dd","16":"2185536ce345059eb521","17":"c6183bf163312b7400dd","18":"b9697b08182003108fab","19":"c0b9796f77f5d7aeddcc","20":"d035ab8c9a25907d3eff","21":"abdacfc7e5c5f8bff1fe","22":"27648783e688a2e96d1b","23":"4ad5733ee91c98cdcb64","24":"46c6562137173c8a8b74","25":"e188872a28bd98aa6881","26":"07e63a4975916d443fd7","27":"74a9254b56ba17e2ec65","28":"d184edd922a0af359c52","29":"3b1eaab0e3f5b48d4851","30":"29331e5d269ed86493d7","31":"040e16152c67a803ab01","32":"f6d162e4b641da5ab6ae","33":"545778b6dce4d026c415","34":"9f5d3ff2dbc8382984d9","35":"40fff437f8f1b0314904","36":"5a141db24725636db23e","37":"a0e9adf881df36924b75","38":"71e514d3249938a2d073","39":"20b6c3615371bc5cea59","40":"a17146e1f31abcefcb4c","41":"4dce531eaf153a196d96","42":"7552e9cf878312969f5f","43":"173f6ee74fe449860ea5","44":"90d2347385ece359c236","45":"ebde52bce27a3d220e34","46":"dca6a02c8d8baacbba0f","47":"519ed916e53319af1de9","48":"d406fcf5c5deaac98129","49":"7ae459bb5e72a0ae58c5","50":"649f9780a5edaec4eb1c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"a4ceecac44264c85db5ffc7c053be1d668a563d6","1":"d1d95a80c372ec5900e3701a5af808ed913408a1","2":"styles","3":"60bd339c77bbb08565e3718576e010113576ed5a","4":"5735565d15280288b03a826f98936cf1739443ba","5":"bc28599f108a18f65c8a668750ca6221ced015bc","6":"1fa6542c36b270a382cfd09df6880ade19db7a3f","7":"231ecdf25ca383381d7680a49c3cb0531a54c36d","8":"eb5a4b780599e191c090b6a3213504cb56648c06","9":"c07283bbcf2ed03c0d7e76967c79f8873c6b2a05","12":"component---src-pages-404-js","13":"component---src-pages-about-js","14":"component---src-pages-activities-js","15":"component---src-pages-adhub-js","16":"component---src-pages-aihub-js","17":"component---src-pages-b-2-b-js","18":"component---src-pages-brandretail-js","19":"component---src-pages-campaign-js","20":"component---src-pages-cdp-js","21":"component---src-pages-childrenprivacy-js","22":"component---src-pages-cookieprivacy-js","23":"component---src-pages-cpm-js","24":"component---src-pages-digitalmarketing-js","25":"component---src-pages-dmhub-js","26":"component---src-pages-durables-js","27":"component---src-pages-financial-js","28":"component---src-pages-fmcg-js","29":"component---src-pages-index-js","30":"component---src-pages-marketingcloud-js","31":"component---src-pages-maturity-js","32":"component---src-pages-modernretail-js","33":"component---src-pages-openhub-js","34":"component---src-pages-partner-js","35":"component---src-pages-pechub-content-list-jsx","36":"component---src-pages-pechub-jsx","37":"component---src-pages-personas-js","38":"component---src-pages-privacy-js","39":"component---src-pages-privatetraffic-js","40":"component---src-pages-royalty-js","41":"component---src-pages-scrm-js","42":"component---src-pages-summits-js","43":"component---src-pages-tags-js","44":"component---src-pages-tahub-js","45":"component---src-pages-update-info-js","46":"component---src-pages-yourtitles-js","47":"component---src-templates-blogs-js","48":"component---src-templates-ccmeaningful-js","49":"component---src-templates-post-layout-jsx","50":"component---src-templates-whitepaper-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"06bf6142f231f01a65d0","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
